import { render } from "./PersonalDataScreen.vue?vue&type=template&id=9c19e70c&scoped=true&lang=html"
import script from "./PersonalDataScreen.vue?vue&type=script&lang=js"
export * from "./PersonalDataScreen.vue?vue&type=script&lang=js"

import "./PersonalDataScreen.vue?vue&type=style&index=0&id=9c19e70c&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_topdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c19e70c"]])

export default __exports__